export default "__VITE_ASSET__BSFDFaH7__"